export default {
    initialiseStore: ({ commit }, state) => commit('initialiseStore', state),
    updateLogin: ({ commit }, login) => commit('updateLogin', login),
    updatePassword: ({ commit }, password) => commit('updatePassword', password),
    updateTerms: ({ commit }, terms) => commit('updateTerms', terms),
    updateMailing: ({ commit }, mailing) => commit('updateMailing', mailing),
    updateName: ({ commit }, name) => commit('updateName', name.trim()),
    updateFirstname: ({ commit }, firstname) => commit('updateFirstname', firstname.trim()),
    updateLastname: ({ commit }, lastname) => commit('updateLastname', lastname.trim()),
    updatePhone: ({ commit }, phone) => {
        commit('updatePhoneCountry', phone.country.iso2);
        commit('updatePhoneNumber', phone.number);
    },
    updatePhoneNumber({ commit }, phoneNumber) {
        commit('updatePhoneNumber', phoneNumber);
    },
    updatePhoneCountry: ({ commit }, phoneCountry) =>
        commit('updatePhoneCountry', phoneCountry.iso2),
    updateCountry: ({ commit }, country) => commit('updateCountry', country.code),
    updateLang: ({ commit }, lang) => commit('updateLang', lang),
    updateRecaptcha: ({ commit }, token) => commit('updateRecaptcha', token),
    updateUtms: ({ commit }, utms) => commit('updateUtms', utms),
    updateGoogle: ({ commit }, google) => commit('updateGoogle', google),
};
